export default __webpack_public_path__ + "static/media/img-0399-serbia-half-face.7d08db20.png";